import { Input as BaseInput } from '@pulse-web-ui/input';
import { styled } from '@pulse-web-ui/theme';

export const Input = styled(BaseInput)`
  font-family: 'SuisseIntl', sans-serif;
`;
